import { useQuery } from '@tanstack/react-query';

import { fetcher } from '~lib/api/fetch';
import { ICompanyWorkLife } from '~types/company';

import QueryKeys from '../queryKeys';
import useGetMyInfoQuery from '../user/useMyInfoQuery';

export default function useCompanyReviewWorkLife(companyHash?: string) {
  const { isActiveUser } = useGetMyInfoQuery();
  const result = useQuery<ICompanyWorkLife>(
    [QueryKeys.companyReviewWorkLife, companyHash],
    () => fetcher(`/api/review/worklife?PK_NM_HASH=${companyHash}`),
    { enabled: !!companyHash && isActiveUser },
  );

  const isEmptyOvertime = Object.values(result.data?.overtime ?? {}).every(
    (obj) => obj.count === 0,
  );
  const isEmptyWeekend = Object.values(result.data?.weekend ?? {}).every((obj) => obj.count === 0);

  return {
    ...result,
    isEmptyOvertime,
    isEmptyWeekend,
    isEmpty: isEmptyOvertime && isEmptyWeekend,
  };
}
